/* Reader for the first-touch attribution cookie written on the marketing site.
 *
 * The writer lives in landing/src/lib/attribution.js and owns the format; this
 * side only reads. The two files must agree on the cookie name and on the key
 * letters, which are short because the cookie rides on every request to
 * complaudax.com. Nothing here writes, so a visitor who arrives straight at
 * app.complaudax.com simply has no attribution, which is the honest answer.
 */
const COOKIE = "cplx_attr";

export const attributionProps = () => {
  if (typeof document === "undefined") return {};
  const hit = document.cookie.split("; ").find((c) => c.startsWith(`${COOKIE}=`));
  if (!hit) return {};
  let a;
  try {
    a = JSON.parse(decodeURIComponent(hit.slice(COOKIE.length + 1)));
  } catch {
    return {};
  }
  const out = {};
  if (a.r) out.initial_referring_domain = a.r;
  if (a.p) out.initial_landing_path = a.p;
  if (a.s) out.initial_utm_source = a.s;
  if (a.m) out.initial_utm_medium = a.m;
  if (a.c) out.initial_utm_campaign = a.c;
  if (a.t) out.initial_visit_at = a.t;
  return out;
};
